<ul [@fadeInXY]="facetNode.isNested" class="facet-level">
    <li [@fadeInXY]="facetNode.isNested">
        <div [@fadeInXY]="facetNode.isNested" class="node-title">
            <span class="toggle placeholder" *ngIf="!facetNode.isNested">
                <i class="fas fa-angle-double-right"></i>
            </span>
            <a class="toggle" (click)="onToggleClick(facetNode)" *ngIf="facetNode.isNested">
                <span class="toggle" [ngClass]="{ visible: facetNode.isNested }">
                    <i
                        [@rotateRight]="facetNode.expanded"
                        class="fas"
                        [ngClass]="{
                            'fa-plus': !facetNode.expanded,
                            'fa-minus': facetNode.expanded,
                        }"
                    ></i>
                </span>
            </a>
            <input
                #checkbox
                type="checkbox"
                [id]="facetNode.facetId"
                [attr.data-gtmlabel]="facetNode.gtmLabel"
                [ngModel]="facetNode.checked"
                (change)="onCheckboxChange($event, facetNode)"
                [indeterminate]="facetNode.indeterminate"
            />
            <label (click)="checkbox.click()" [for]="facetNode.facetId">{{
                facetNode.node.title
            }}</label>
        </div>
        <div [@fadeInXY]="facetNode.isNested" *ngIf="facetNode.isNested && facetNode.expanded">
            <app-nested-facet-nodes
                *ngFor="let child of children"
                [facet]="facet"
                [facetNode]="child"
            ></app-nested-facet-nodes>
        </div>
    </li>
</ul>
